import React, { useState, useContext } from 'react';
import { toast } from 'react-toastify'; 
// import { createEmployee, updateEmployee } from '../../../Utility/Api'; 
import { WarehouseContext } from '../../../Utility/UserContext';

const EmployeeForm = ({ employee, closeModal, refreshList }) => {
  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
  
  const [formData, setFormData] = useState({
    name: employee ? employee.name : '',
    role: employee ? employee.role : '',
    shop: employee ? employee.shop : '',
    branch: employee ? employee.branch : '',
    salary: employee ? employee.salary : '',
  });

  const [errors, setErrors] = useState({
    name: '',
    role: '',
    shop: '',
    branch: '',
    salary: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    setErrors({
      ...errors,
      [name]: ''
    });
  };

  const handleSubmit = async (e) => {
    showLoader();
    e.preventDefault();

    if (!formData.name || !formData.role || !formData.shop || !formData.branch || !formData.salary) {
      toast.error('All fields are required');
      return;
    }

    const formDataPayload = new FormData();
    formDataPayload.append('name', formData.name);
    formDataPayload.append('role', formData.role);
    formDataPayload.append('shop', formData.shop);
    formDataPayload.append('branch', formData.branch);
    formDataPayload.append('salary', formData.salary);
    formDataPayload.append('shop_id', shopItem.id);

    try {
      if (employee) {
        // await updateEmployee(employee.id, formDataPayload);  
        toast.success('Employee updated successfully');
      } else {
        // await createEmployee(formDataPayload);  
        toast.success('Employee added successfully');
      }
      closeModal();
      refreshList();
      hideLoader();
    } catch (error) {
      console.error('Error saving employee data:', error);
      toast.error('Error saving employee');
      hideLoader();
    }
  };

  return (
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontFamily: 'poppins' }}>
              {employee ? 'Edit Employee' : 'Add Employee'}
            </h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
          </div>
          <div className="modal-body" style={{ fontFamily: 'poppins' }}>
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.name && <small className="text-danger">{errors.name}</small>}
              </div>

              <div className="form-group mb-3">
                <label>Role</label>
                <input
                  type="text"
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.role && <small className="text-danger">{errors.role}</small>}
              </div>

              <div className="form-group mb-3">
                <label>Shop</label>
                <input
                  type="text"
                  name="shop"
                  value={formData.shop}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.shop && <small className="text-danger">{errors.shop}</small>}
              </div>

              <div className="form-group mb-3">
                <label>Branch</label>
                <input
                  type="text"
                  name="branch"
                  value={formData.branch}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.branch && <small className="text-danger">{errors.branch}</small>}
              </div>

              <div className="form-group mb-3">
                <label>Salary (per month)</label>
                <input
                  type="number"
                  name="salary"
                  value={formData.salary}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                {errors.salary && <small className="text-danger">{errors.salary}</small>}
              </div>

              <button type="submit" className="btn btn-success float-end">
                {employee ? 'Update Employee' : 'Add Employee'}
              </button>
              <button
                type="button"
                className="btn btn-secondary float-end me-1"
                onClick={closeModal}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeForm;
